import 'slick-carousel/slick/slick'

export default class ShapedCardsSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-shaped-cards-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.each((index, element) => {
                const $slider = $(element);
                const sliderId = $slider.data('slider-id');

                $slider.slick({
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    appendDots: $(`.js-shaped-cards-slider-dots[data-slider-id="${sliderId}"]`),
                    arrows: false,
                    dots: true,

                    responsive: [
                        {
                            breakpoint: 1280,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
            });
        }

    }

};

new ShapedCardsSlider();